import { render, staticRenderFns } from "./NeuralNew.vue?vue&type=template&id=9f4580e4&scoped=true&"
import script from "./NeuralNew.vue?vue&type=script&lang=js&"
export * from "./NeuralNew.vue?vue&type=script&lang=js&"
import style0 from "./NeuralNew.vue?vue&type=style&index=0&id=9f4580e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4580e4",
  null
  
)

export default component.exports